/**
 * Document Imports Vuex State
 * Initial state for the document import feature.
 */

import { WIZARD_STEPS } from '../config/wizardSteps';

export default {
  // === Upload Dialog State ===
  uploadDialogOpen: false,

  // === Wizard State ===
  wizardStep: WIZARD_STEPS.CONFIGURE,

  // === Scope Selection (Mutually Exclusive) ===
  scopeType: 'Facility', // 'Facility' | 'FacilityGroup'
  selectedFacilityId: null,
  selectedFacilityGroupId: null,

  // === Upload Configuration ===
  selectedDocumentTypeId: null,

  // === Files to Import (Editable Rows) ===
  pendingFiles: [],
  // Structure: [{ file, fileName, documentNumber, documentTitle, documentTypeId, revisionNumber, isValid, errors }]
  selectedFileIndexes: [],

  // === Existing Documents (Main Page Table) ===
  documents: [],
  documentsTotal: 0,

  // === Pagination Options ===
  tableOptions: {
    page: 1,
    itemsPerPage: 15,
    sortBy: ['createDate'],
    sortDesc: [true],
  },

  // === Document Types Cache ===
  documentTypes: [],
  documentTypesLoaded: false,

  // === Loading States ===
  loading: false,
  uploading: false,
  importing: false,
  deleting: false,

  // === Error State ===
  error: null,

  // === Import Result ===
  importResult: null,
};
